import { Environment } from './environment.model';

export const ENV: Environment = {
  mode: 'Development',
  wsUrl: 'https://storetoshow.x-ray.ch/',
  apikey: 'F9nbqgv0M2do8NCWKkjm4yN7yYtZTzMd',
  pspLicensekey: 'loxqxh7shvAaLaglt8BSiJ9FLCDK4O-YBsgnPc7ahUYbbh030NtKYNKP4hoxnUJ5TN_c7dT2ViEuQDPqKMn8hEoeOeNolXQ-aK8tCN_RqK3rjfA8NB0wcf9cfRCDmxegISgmJ3xt3R5F7d_qnBZ8N8c0p2jhK4AHy8tz73F0s8vKlDLgeRD7VtmN3oW0egVUR2o7yTOWajuV3BGb8wvpQG7YBD5PrGwPl0sK74zxaQDEGjfrj5qEIyfBtmOO7tr9JCtu8N9AWVUJ4YBuprqUg0yC7pIt2uK1p3XnCWqJqmwjOJW5XOz1CSypGswbofjLk_CHQuLuau0tPs9HqXWr40DBKgxIWdQ8W_fe1gzyzF5DQZKQQc7b22e_aKSxtbgwBBjWtE1ppFEWxeGN7SnHHmiNIvsW_2_dbfAz8-WwLQ62F5dmS6CDKNh1rxwRcxhmTQEkHh7UytqRPNnhmLmVd1tZ94rx7JOEtgj4y7ZMZ-_hWVXFqt9ZC5IjTtL-S66z2aX8leUAfiwAlSpPOKOfOe5OEjmsDDCpjLoy3MimvtC_HI1PbxEaEeOgpV_gZLyucGEIxZW7cWr2kyg0OdCu5dbMhnkCjXEeI61BEQdEtmi1h76yN1T3C1Lauht2tBBVOERDHPZbJOBT9Hiaca01woI8SJIvK6FTqk2t2BTD59xjQtdjP1WGqgQ-LvGSKU0A'
}


// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts